import { FunctionComponent } from 'react';
import i18n from 'i18n';
import TableBuilder from 'components/Table';
import DefaultAdminActionField from 'pages/administration/components/DefaultAdminActionField';

interface ListI {
  typeItems: $Lns.PeripheralType[];
  onEdit: (userItem: $Lns.PeripheralType) => void;
  onDelete: (userItem: $Lns.PeripheralType) => void;
}

const List: FunctionComponent<ListI> = ({
  typeItems,
  onEdit,
  onDelete
}: ListI) => {
  const rows = [
    i18n.t('pages.administration.peripheralTypes.tableRow.name'),
    i18n.t('pages.administration.peripheralTypes.tableRow.key'),
    i18n.t('tableRow.actions')
  ];

  const cells = typeItems.map((item: $Lns.PeripheralType) => {
    return {
      fields: {
        name: { value: item.name },
        key: { value: item.key },
        actions: {
          value: (
            <DefaultAdminActionField
              target={item.name}
              onEdit={() => onEdit(item)}
              onDelete={() => onDelete(item)}
            />
          )
        }
      }
    };
  });

  return <TableBuilder rows={rows} cells={cells} />;
};

export default List;
